import React, {useState} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {withRouter} from 'react-router-dom';
import { List } from 'antd-mobile';
import { Icon } from 'react-onsenui';
import { me, extract } from '../../../../../../../../helpers';
import { create } from '../../../../../../../../services/live';
import { createLiveForMatch, cancelLive } from '../../../../../../../../actions/matchDataActions';
import BecomingLiveScorerConfirmationModal from '../../../../../../../modals/BecomingLiveScorerConfirmationModal';
import ServerErrorModal from '../../../../../../../modals/error/ServerErrorModal';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_HOST } from '../../../../../../../../config.env';

const BtnBecomingLiveScorer = props => {
    const access = props.connexionReducer
    const [show, setShow] = useState(false);
    const [live, setLive] = useState([]);
    const [error, setError] = useState(null);

    return (
        <List>
            <List.Item
                arrow='horizontal'
                thumb={<div style={{color: '#004586'}}><Icon size={18} icon='md-eye' /></div>}
                onClick={() => handleClick(props, access, setLive ,() => setShow(!show), (reject) => setError(reject))}
            ><div className='common' style={{fontWeight: '700'}}>Deviens Live Scorer pour ce match</div></List.Item>
            <BecomingLiveScorerConfirmationModal 
                show={show}
                cancel={() => {
                    const id = extract(live['@id'], '/', 3);
                    axios.delete(`${API_HOST}/api/lives/${id}`, {headers: {
                        Accept: 'application/ld+json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${access}`
                    }}).then(() => {
                        props.cancelLive(id, props.maNo);
                        setShow(false);
                    })
                }} 
                done={()=> {
                    props.createLiveForMatch(live, props.maNo);
                    setShow(false);
                }} 
            />
            <ServerErrorModal error={error} />
        </List>
    )
}

const handleClick = (props, access, setLive ,resolve, reject) => {
    if( me().nickname === null || me().nickname === '' || me().nickname === undefined) {
        props.history.push(`/onboarding/${props.maNo}?homeTeam=${props.homeTeam}&awayTeam=${props.awayTeam}&matchDate=${props.date}`);
    }
    else {
        if(props.maNo){
            create(props.maNo, props.homeTeam, props.awayTeam, props.date, access).then(response => {
                if(response.status === 201) {
                    window.postMessage(JSON.stringify({
                        action: 'trackEventWithCollection',
                        parameters: {
                            label: 'declared_live_scorer',
                            collection: {match_name: `${props.homeTeam} x ${props.awayTeam}`}
                        }
                    }), '*');
                    setLive(response.data)
                    resolve();
                }
            })
            .catch(error => {
                const {status,data} = error.response || {status: 500, data: 'une erreur est survenue'};
                reject({code: status || 500, data});
            });
        }
    }
}

const mapStateToProps = ({connexionReducer}) => ({connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({createLiveForMatch, cancelLive}, dispatch);

BtnBecomingLiveScorer.propTypes = {
    createLiveForMatch: PropTypes.func.isRequired,
    maNo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    homeTeam: PropTypes.string.isRequired,
    awayTeam: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BtnBecomingLiveScorer));